<template>
<div>
	<alert :conditional="this.$route.query.plan === 'approved'"
			:classFather="'alert bg-red'"
			:message="'message-after-register'"
			:title="''"
			:iconClass="'icon fas fa-warning'"
			:linkShow="false"
			:linkTo="''"
			:linkText="''"
			:altLink="''"
			:close-button="true">
	</alert>
	<div class="login__content">
			<h1>Mandato Aberto</h1>
			<form @submit.prevent="authenticate" class="form--login">
				<div class="form__group">
					<label for="email">Email</label>
					<input type="email" id="email" placeholder="E-mail" v-model="formLogin.email" maxlength="256" required="true">
				</div>
				<div class="form__group">
					<label for="password">Password</label>
					<input type="password" id="password" placeholder="Senha" v-model="formLogin.password" required="true">
				</div>


				<div class="login__submit">
					<div class="form__validation" v-show="errorForm(error, 'email') ">
						<p><i class="fas fa-times-circle-o"></i> {{ errorForm(error, 'email') | translate | capitalize }}</p>
					</div>
					<div class="form__validation" v-show="errorForm(error, 'approved') ">
						<p><i class="fas fa-times-circle-o"></i> {{ errorForm(error, 'approved') | translate | capitalize }}</p>
					</div>
					<div class="form__validation" v-show="genericError(error) ">
						<p><i class="fas fa-times-circle-o"></i> {{ genericError(error) | translate | capitalize }}</p>
					</div>
					<div class="form__group submit__content">
						<button type="submit" :aria-busy="loading">
							{{ (loading) ? 'wait' : 'enter' | translate | capitalize  }}
						</button>
					</div>
				</div>

			</form>
			<div class="login__call-to-action">
				<router-link v-bind:to="'reset-password-email'">{{ 'forgot-password' | translate | capitalize }}</router-link>
				<p v-if="url.indexOf('mandatoaberto') !== -1">Não tem conta?<router-link v-bind:to="'registro'"> {{ 'make-your-register' | translate | capitalize }}</router-link></p>
			</div>
	</div>
</div>
</template>

<script>

	import error from '../../methods/errors';
	import alert from '../alert/alert.vue';

	export default {
		name: 'login',
		components: {
			alert,
		},
		data() {
			return {
				formLogin: {},
				error: {
					approved: false,
				},
				url: window.location.host,
				loading: false,
			};
		},
		beforeCreate() {
			const session = {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			};
			if (session.apiKey) {
				this.$router.push('/indicadores');
			}
		},
		watch: {
			/* eslint-disable object-shorthand */
			user() {
				this.$router.go('/indicadores');
			},
			errors() {
				this.error = this.$store.state.error;
			},
		},
		computed: {
			user() {
				return this.$store.state.user;
			},
			errors() {
				return this.$store.state.error;
			},
		},
		methods: {
			authenticate() {
				this.loading = true;
				this.$store.dispatch('authenticLogin', this.$data.formLogin)
					.catch(() => {
						this.loading = false;
					});
			},
			errorForm(obj, field) {
				const msg = error.errorForm(obj, field);
				return msg;
			},

			genericError(obj) {
				const msg = error.genericError(obj);
				return msg;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/login/login.vue